
<div v-if="!renderData.loading">
  <component :is="renderData.currentThemeInfo" :slotProps="slotProps">
  </component>
</div>
